import React from 'react';
import './blast-page-header.css';

/**
 * Shared header for all Blast Tournament screens.
 *
 * Props
 *   leftLink  – { label: string, onClick: fn }  (required)
 *   rightLink – { label: string, onClick: fn }  (required)
 *   title     – string, defaults to "Blast Tournament"
 */
export const BlastPageHeader = ({
  leftLink,
  rightLink,
  title = 'Blast Tournament',
}) => (
  <div className="blast-page-header">
    <nav className="blast-header-nav">
      {leftLink
        ? <button className="blast-nav-link" onClick={leftLink.onClick}>{leftLink.label}</button>
        : <span />}
      {rightLink
        ? <button className="blast-nav-link" onClick={rightLink.onClick}>{rightLink.label}</button>
        : <span />}
    </nav>
    <h1 className="blast-header-title">{title}</h1>
  </div>
);

export default BlastPageHeader;
